@let action = data();
<div class="flex flex-col gap-4 items-start w-full p-8">
	<app-ultra-icon [svgIcon]="action.svgIcon"></app-ultra-icon>
	<div class="flex flex-col items-start text-start">
		<span class="text-md"> {{ action.title | transloco }}</span>
		<p class="subtle-text">{{ action.descrption | transloco }}</p>
	</div>
</div>
